<template>
  <div id="line-official-line-official-account-choose">
    <div class="text-center _fs-24 _fs-sm-36">
      {{ header }}
    </div>

    <div class="d-flex flex-column _pt-20 _pt-sm-30">
      <div class="text-center mb-2">
        กรุณาเลือก Basic ID ของท่าน
      </div>

      <v-row justify="center">
        <v-col sm="6">
          <div v-if="hasLineOfficialAccount">
            <v-checkbox
              v-for="ownLineOfficialAccount in lineOfficialAccounts"
              :key="ownLineOfficialAccount._id"
              v-model="chosenBasicId"
              :label="ownLineOfficialAccount.lineOfficialAccount.basicId"
              :value="ownLineOfficialAccount.lineOfficialAccount._id"
              hide-details
              class="mt-1"
            >
              <span slot="label">
                {{ ownLineOfficialAccount.lineOfficialAccount.basicId }}
                <span
                  v-if="ownLineOfficialAccount.lineOfficialAccount.displayName"
                  class="primary--text"
                >
                  ({{ ownLineOfficialAccount.lineOfficialAccount.displayName }})
                </span>
              </span>
            </v-checkbox>
          </div>
          <div
            v-else
            class="text-center py-10 grey--text">
            ไม่พบ Basic ID ของท่านในระบบ
          </div>
        </v-col>
      </v-row>

      <div class="d-flex flex-column align-center mt-4">
        <v-btn
          :color="buttonSubmitColor"
          rounded
          :disabled="!chosenBasicId.length"
          @click="showDialog = true">
          {{ buttonSubmit }}
        </v-btn>

        <v-btn
          class="mt-4"
          text
          color="primary"
          @click="toggleHideAccount">
          <v-icon class="mr-1">
            mdi-eye-outline
          </v-icon>
          {{ buttonToggleHideAccount }}
        </v-btn>
      </div>
    </div>

    <v-dialog
      v-model="showDialog"
      max-width="600">
      <v-card class="pa-10">
        <v-card-title class="justify-center">
          <v-btn
            :icon="true"
            class="_line-oa-dialog-close"
            @click="showDialog = false">
            <v-icon :size="32">
              mdi-close
            </v-icon>
          </v-btn>

          <v-icon
            color="black"
            :size="100">
            {{ dialogIcon }}
          </v-icon>
        </v-card-title>
        <v-card-text>
          <p class="text-center _fs-24">
            {{ dialogContent }} <br />
            ที่เลือกไว้ใช่หรือไม่?
          </p>
        </v-card-text>
        <v-card-actions class="pb-8">
          <v-spacer />
          <v-btn
            color="primary"
            rounded
            min-width="150"
            outlined
            exact
            @click="showDialog = false">
            ยกเลิก
          </v-btn>
          <v-btn
            class="ml-4"
            color="primary"
            rounded
            min-width="150"
            @click="submit">
            ยืนยัน
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { mapWaitingActions } from 'vue-wait'

export default {
  name: 'LineOfficialAccountHideComponent',
  data() {
    return {
      actionHide: true,
      chosenBasicId: [],
      showDialog: false
    }
  },
  computed: {
    ...mapState('User', ['userProfile']),
    ...mapGetters({
      hasLineOfficialAccount: 'User/hasLineOfficialAccount',
      ownLineOfficialAccounts: 'User/ownLineOfficialAccounts'
    }),
    header() {
      return this.actionHide ? 'เลือก Basic ID' : 'Basic ID ที่ถูกซ่อนไว้'
    },
    dialogIcon() {
      return this.actionHide ? 'mdi-eye-off-outline' : 'mdi-eye-outline'
    },
    dialogContent() {
      return this.actionHide ? 'ท่านยืนยันที่จะทำการซ่อนบัญชี' : 'ท่านยืนยันที่จะทำการแสดงบัญชี'
    },
    buttonSubmit() {
      return this.actionHide ? 'ซ่อนบัญชี' : 'แสดงบัญชี'
    },
    buttonSubmitColor() {
      return this.actionHide ? 'error' : 'primary'
    },
    buttonToggleHideAccount() {
      return this.actionHide ? 'ดู Basic ID ที่ซ่อนไว้' : 'ดู Basic ID ที่ใช้งานอยู่'
    },
    lineOfficialAccountsStatusHide() {
      return this.ownLineOfficialAccounts.filter((item) => !item.lineOfficialAccount.hide)
    },
    lineOfficialAccountsStatusShow() {
      return this.ownLineOfficialAccounts.filter((item) => item.lineOfficialAccount.hide)
    },
    lineOfficialAccounts() {
      return this.actionHide
        ? this.lineOfficialAccountsStatusHide
        : this.lineOfficialAccountsStatusShow
    }
  },
  methods: {
    ...mapActions({
      updateBatchHideLineOfficialAccount: 'User/updateBatchHideLineOfficialAccount'
    }),
    ...mapWaitingActions('User', {
      updateBatchHideLineOfficialAccount: 'app loading'
    }),
    isLineOfficialAccountInactive(ownLineOfficialAccount) {
      return (
        ownLineOfficialAccount.status === 'inactive'
        || ownLineOfficialAccount.lineOfficialAccount.status === 'inactive'
      )
    },
    toggleHideAccount() {
      if (this.actionHide) {
        if (
          Array.isArray(this.lineOfficialAccountsStatusShow)
          && this.lineOfficialAccountsStatusShow.length
        ) {
          this.actionHide = false
        } else {
          this.$swal({
            title: 'ไม่มี Basic ID ที่ท่านซ่อนไว้',
            icon: 'error'
          })
        }
      } else {
        this.actionHide = true
      }
    },
    async submit() {
      await this.updateBatchHideLineOfficialAccount({
        lineOaId: this.chosenBasicId,
        hide: this.actionHide
      }).then(() => {
        this.$swal({
          title: 'ทำรายการสำเร็จแล้ว',
          icon: 'success'
        })
        this.chosenBasicId = []
        this.showDialog = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
._cursor-pointer {
  cursor: pointer;
}

._line-oa-dialog-close {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1;
}
</style>
